/* Pure JST calendar. Picker rule: Calendar Master deliveryDateExt.js Rt(). */
(function (root) {
  'use strict';
  const DAY = 86400000;
  const TIME_SLOTS = Object.freeze(typeof module !== 'undefined' && module.exports
    ? require('node:fs').readFileSync(require('node:path').join(__dirname, '../snippets/delivery-time-slots.liquid'), 'utf8').trim().split('|')
    : JSON.parse(document.querySelector('[data-delivery-time-slots]').textContent));
  // Copied from docs/research/apps/sources/calendar-public-config.json, 2026-10-09.
  const FALLBACK_CALENDAR = Object.freeze({
    closedWeekdays: Object.freeze([0, 6]),
    noDeliveryWeekdays: Object.freeze([]),
    closedDates: Object.freeze(['2025-09-15', '2025-09-23', '2025-10-13', '2025-11-03', '2025-11-24', '2026-01-01', '2026-01-02', '2026-01-03', '2026-01-04', '2026-01-05', '2025-12-30', '2025-12-31', '2026-04-29', '2026-05-04', '2026-05-05', '2026-05-06', '2026-07-20', '2026-08-11', '2026-09-21', '2026-09-22', '2026-09-23', '2026-10-12', '2026-11-03', '2026-11-23', '2027-01-01', '2027-01-11', '2027-02-11', '2027-02-23', '2027-03-22']),
    noDeliveryDates: Object.freeze(['2025-12-30', '2025-12-31', '2026-01-01', '2026-01-02', '2026-01-03', '2026-01-04', '2026-01-05'])
  });
  function iso(day) { return new Date(day * DAY).toISOString().slice(0, 10); }
  function dateDay(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return NaN;
    const day = Date.parse(value + 'T00:00:00Z') / DAY;
    return Number.isInteger(day) && iso(day) === value ? day : NaN;
  }
  function calendarDate(value) {
    if (typeof value !== 'string') return null;
    if (Number.isFinite(dateDay(value))) return value;
    // Shopify ISO dates/date_times, including Liquid's spaced numeric offset.
    const match = /^(\d{4}-\d{2}-\d{2})[T ]([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(\.\d{1,3})?\s*(Z|[+-](?:[01]\d|2[0-3]):?[0-5]\d)$/.exec(value);
    if (!match || !Number.isFinite(dateDay(match[1]))) return null;
    const offset = match[6] === 'Z' ? 'Z' : match[6].replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    const instant = Date.parse(`${match[1]}T${match[2]}:${match[3]}:${match[4]}${match[5] || ''}${offset}`);
    return Number.isFinite(instant) ? iso(Math.floor((instant + 9 * 3600000) / DAY)) : null;
  }
  function normalizeCalendar(config = {}) {
    if (config.calendarRules) {
      const rules = JSON.parse(config.calendarRules);
      if (!rules || Array.isArray(rules) || typeof rules !== 'object' ||
          Object.keys(rules).some(key => !Object.keys(FALLBACK_CALENDAR).includes(key)) ||
          Object.keys(FALLBACK_CALENDAR).some(key => !Array.isArray(rules[key]))) throw new RangeError('Invalid calendar settings');
      config = { ...rules, ...Object.fromEntries(Object.entries(config).filter(([, value]) => value != null)) };
    }
    let invalid = false;
    const calendar = Object.fromEntries(Object.keys(FALLBACK_CALENDAR).map(key => {
      if (config[key] == null) return [key, [...FALLBACK_CALENDAR[key]]];
      if (!Array.isArray(config[key])) { invalid = true; return [key, []]; }
      const values = config[key].map(value => key.endsWith('Weekdays')
        ? (Number.isInteger(value) && value >= 0 && value <= 6 ? value : null)
        : calendarDate(value));
      if (values.includes(null)) invalid = true;
      return [key, values.filter(value => value !== null)];
    }));
    return { calendar, invalid };
  }
  function dispatchDay(now, config = {}) {
    const instant = new Date(now).getTime();
    const cutoff = typeof config.cutoff === 'string' ? config.cutoff.trim() : config.cutoff ?? '10:00';
    if (!Number.isFinite(instant) || !/^(\d|[01]\d|2[0-3]):[0-5]\d$/.test(cutoff)) {
      throw new RangeError('Invalid delivery rules');
    }
    const { calendar: cal, invalid } = normalizeCalendar(config);
    if (invalid) throw new RangeError('Invalid calendar entry; delivery selection requires review.');
    const jst = new Date(instant + 9 * 3600000);
    const today = Math.floor(jst.getTime() / DAY);
    const minutes = jst.getUTCHours() * 60 + jst.getUTCMinutes();
    const [hour, minute] = cutoff.split(':').map(Number);
    const ship = nextOpenDispatchDay(today + (minutes >= hour * 60 + minute ? 1 : 0), cal);
    return { ship, calendar: cal };
  }
  function nextOpenDispatchDay(ship, cal) {
    let attempts = 0;
    while (cal.closedDates.includes(iso(ship)) || cal.closedWeekdays.includes(new Date(ship * DAY).getUTCDay())) {
      if (++attempts > 366) throw new RangeError('No shipping day');
      ship++;
    }
    return ship;
  }
  function deliveryAllowed(day, calendar) {
    return !calendar.noDeliveryDates.includes(iso(day)) && !calendar.noDeliveryWeekdays.includes(new Date(day * DAY).getUTCDay());
  }
  function estimateArrival(now, transitDays, config = {}) {
    if (!Number.isInteger(transitDays) || transitDays < 1 || transitDays > 365) throw new RangeError('Invalid transit days');
    const instant = new Date(now).getTime();
    if (!Number.isFinite(instant)) throw new RangeError('Invalid order date');
    const { calendar, invalid } = normalizeCalendar(config);
    if (invalid) throw new RangeError('Invalid calendar entry; delivery estimate requires review.');
    const purchase = Math.floor((instant + 9 * 3600000) / DAY);
    // The estimate never promises dispatch on the order date; the picker keeps its cutoff.
    const ship = nextOpenDispatchDay(purchase + 1, calendar);
    let arrival = ship + transitDays;
    let attempts = 0;
    while (!deliveryAllowed(arrival, calendar)) {
      if (++attempts > 366) throw new RangeError('No delivery day');
      arrival++;
    }
    return { purchaseDate: iso(purchase), shipDate: iso(ship), arrivalDate: iso(arrival) };
  }
  function selectableDates(now, config = {}) {
    const lead = Number(config.leadDays ?? 3);
    const range = Number(config.rangeDays ?? 60);
    if (!Number.isInteger(lead) || lead < 0 || lead > 365 || !Number.isInteger(range) || range < 1 || range > 365) {
      throw new RangeError('Invalid delivery rules');
    }
    const { ship, calendar: cal } = dispatchDay(now, config);
    // ship is the first countable day (today only before cutoff and when open).
    // Rt() starts the window AFTER counting lead open shipping days, then moves
    // that start past shipping closures. With lead 0, ship is already the start.
    let first = ship;
    for (let counted = 0; counted < lead; counted++) first = nextOpenDispatchDay(first, cal) + 1;
    first = nextOpenDispatchDay(first, cal);
    // Later shipping closures stay selectable; only delivery exclusions filter them.
    const dates = [];
    for (let day = first; day < first + range; day++) {
      if (deliveryAllowed(day, cal)) dates.push(iso(day));
    }
    return { dates, earliest: dates[0] ?? '', latest: dates.at(-1) ?? '', shipDate: iso(ship) };
  }
  function deliveryAttributes(enabled, date, time, now, config = {}) {
    if (!enabled) return { delivery_date: '', delivery_time: TIME_SLOTS.at(-1) };
    if (!Number.isFinite(dateDay(date)) || !selectableDates(now, config).dates.includes(date) || !TIME_SLOTS.includes(time)) {
      throw new RangeError('Invalid delivery selection');
    }
    return { delivery_date: date, delivery_time: time };
  }
  function formatDate(value, locale = 'ja') {
    if (!Number.isFinite(dateDay(value))) throw new RangeError('Invalid display date');
    return new Intl.DateTimeFormat(locale === 'ja' ? 'ja-JP' : locale, {
      timeZone: 'Asia/Tokyo', year: 'numeric', month: 'long', day: 'numeric', weekday: 'short'
    }).format(new Date(value + 'T00:00:00+09:00'));
  }
  const api = Object.freeze({ TIME_SLOTS, FALLBACK_CALENDAR, normalizeCalendar, dispatchDay, estimateArrival, selectableDates, deliveryAttributes, formatDate });
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ChaponDelivery = api;
})(typeof globalThis === 'undefined' ? this : globalThis);
